export const coordinateConvert = (
  coo: null | string,
  type: "timestamp" | "x" | "y",
  asset?: "video",
): number | string => {
  if (type === "timestamp") {
    return Number(coo?.split(",")[2]);
  }

  const position = { timestamp: 3, x: 0, y: 1 };
  const coords = coo?.split(",")[position[type]];

  if (asset) {
    return coords ?? "0%";
  }

  const removePercent = coords?.replace("%", "");
  const num = Number(removePercent);

  return Number.isNaN(num) ? 0 : num / 100;
};
